export const getHeaders = (isCheckBox: boolean) => [
  { content: "" },
  { content: "Inncode", isSorting: true, isCheckBox },
  { content: "Suggested Plans", isSorting: true },
  { content: "Brand", isSorting: true },
  { content: "Region", isSorting: true }
];

export const innerTableHeaders = [
  { content: "Priority" },
  { content: "Suggested Plans" },
  { content: "Suggested By" },
  { content: "Submission Type" },
  { content: "Expiration Date" },
  { content: "Remove" }
];
